<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      :vertical="false"
      :timeout="timeout"
      top="top"
      :color="tipo"
      elevation="5"
      multi-line
      right
      shaped
    >
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <h2 class="titulo mb-2">Usuários</h2>
        <!-- <h3>Gerencie os usuários do sistema</h3> -->
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <br />
    <v-container class="d-inline-flex align-center justify-space-between pa-0">
      <v-btn
        color="primary"
        class="btn-primary ml-0 mb-2 mr-5"
        :loading="carregando"
        @click="abrirModalUsuario(null)"
        >Adicionar</v-btn
      >
      <v-checkbox
        v-model="mostrarInativos"
        :label="`Mostrar usuários inativos`"
      ></v-checkbox>
      <!-- TODO Resolver espaçamento com grid -->
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="pesquisar"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
      ></v-text-field>
    </v-container>

    <v-data-table
      :headers="headers"
      :search="pesquisar"
      :custom-filter="pesquisaPersonalizada"
      :items="mostrarInativos ? usuarios : usuariosAtivos"
      class="elevation-1"
      :loading="carregando"
      loading-text="Carregando informações..."
      sort-by="id"
      sort-desc
    >
      <!-- eslint-disable-next-line -->
      <template v-slot:item.setores="{ item }">
        <div class="flex-row-chips">
          <span v-for="item in item.setores" :key="item.id">
            <v-chip
              outlined
              class="mr-2 my-2 chip-min-width"
              small
              color="primary"
              dark
            >
              <span class="chip-font-size">{{ item.nome }}</span>
            </v-chip>
          </span>
        </div>
      </template>

      <template slot="no-data">
        <div v-if="erroConexao">
          <v-icon class="ml-3" color="red">mdi-alert-circle-outline</v-icon>
          <span class="ml-3 texto-erro-conexao">Erro de conexão</span>
        </div>
        <span v-if="usuarios.length === 0 && !erroConexao"
          >Não há dados pra mostrar</span
        >
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              small
              :color="item.dataInativacao ? 'disable' : 'accent'"
              dark
              class="chip-min-width"
              v-bind="attrs"
              v-on="on"
            >
              <span class="chip-font-size">
                {{ item.dataInativacao ? "Inativo" : "Ativo" }}
              </span>
            </v-chip>
          </template>
          <span>{{
            item.dataInativacao
              ? "Inativado em " + formatarData(item.dataInativacao)
              : "Usuário ativo"
          }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.options`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-0"
              color="primary"
              @click="abrirModalUsuario(item)"
              :disabled="!!item.dataInativacao"
              text
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip v-if="item.dataInativacao == null" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-0 ml-2"
              color="primary"
              @click="abrirModalInativar(item.id, item.login)"
              text
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon> mdi-account-cancel </v-icon>
            </v-btn>
          </template>
          <span>Inativar</span>
        </v-tooltip>

        <v-tooltip v-else top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-0 ml-2"
              color="primary"
              @click="abrirModalAtivar(item.id, item.login)"
              text
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon> mdi-account-check </v-icon>
            </v-btn>
          </template>
          <span>Ativar</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ModalUsuario
      v-if="mostrarModalUsuario"
      @fecharModal="fecharModalUsuario"
      @adicionarUsuario="adicionarUsuario"
      @erroAdicionarUsuario="erroAdicionarUsuario"
      @editarUsuario="editarUsuario"
      @erroEditarUsuario="erroEditarUsuario"
      :setores="setoresApi"
      :perfis="perfisApi"
      :usuarioSelecionado="usuarioSelecionado"
    />
    <ModalInativar
      v-if="mostrarModalInativar"
      @fecharModal="fecharModalInativar"
      @inativarUsuario="inativarUsuario"
      @erroInativarUsuario="erroInativarUsuario"
      :idUsuarioSelecionado="idUsuarioSelecionado"
      :loginUsuarioSelecionado="loginUsuarioSelecionado"
    />
    <ModalAtivar
      v-if="mostrarModalAtivar"
      @fecharModal="fecharModalAtivar"
      @ativarUsuario="ativarUsuario"
      @erroAtivarUsuario="erroInativarUsuario"
      :idUsuarioSelecionado="idUsuarioSelecionado"
      :loginUsuarioSelecionado="loginUsuarioSelecionado"
    />
  </v-container>
</template>

<script>
import mixinMensagen from "@/mixin/mixin-mensagem";
import usuarioApi from "@/api/usuario/usuario-api";
import setorApi from "@/api/setor/setor-api";
import perfilApi from "@/api/perfil/perfil-api";
import Usuario from "@/model/usuario/Usuario";
import Setor from "@/model/usuario/Setor";
import Perfil from "@/model/usuario/Perfil";
import ModalUsuario from "@/components/modal/ModalUsuario.vue";
import ModalInativar from "@/components/modal/ModalInativar.vue";
import ModalAtivar from "@/components/modal/ModalAtivar.vue";
import formatadorData from "@/utils/data";
import { reject } from "q";

export default {
  components: { ModalUsuario, ModalInativar, ModalAtivar },
  name: "Usuarios",
  mixins: [mixinMensagen],
  data() {
    return {
      erroConexao: false,
      carregando: true,
      headers: [
        {
          text: "Código",
          align: "start",
          value: "id",
          width: "110px",
        },
        { text: "Login", value: "login", width: "200px" },
        { text: "Perfil", value: "perfil.descricao", width: "115px" },
        { text: "Status", value: "status", width: "115px" },
        { text: "Setores", value: "setores" },
        {
          text: "",
          value: "options",
          align: "right",
          width: "115px",
          sortable: false,
        },
      ],
      mostrarInativos: false,
      usuarioSelecionado: new Usuario(),
      idUsuarioSelecionado: 0,
      loginUsuarioSelecionado: "",
      usuarios: [],
      usuariosAtivos: [],
      setoresApi: [],
      perfisApi: [],
      mostrarModalUsuario: false,
      mostrarModalInativar: false,
      mostrarModalAtivar: false,
      pesquisar: "",
    };
  },
  methods: {
    async obterDados() {
      this.carregando = true;

      try {
        await this.obterUsuarios();
        await this.obterSetores();
        await this.obterPerfis();
      } catch (error) {
        this.erroConexao = true;
        this.carregando = false;
        this.dispararMensagem(
          (error &&
            error.data &&
            error.data.erros &&
            error.data.erros.join(" ")) ||
            "Não foi possível se comunicar com o servidor!",
          "error",
          3000
        );
      }
      this.carregando = false;
    },

    pesquisaPersonalizada(valor, pesquisa, item) {
      if (Array.isArray(valor)) {
        return valor.some((item) =>
          Object.values(item).some(
            (v) =>
              v && v.toString().toLowerCase().includes(pesquisa.toLowerCase())
          )
        );
      }
      return Object.values(item).some(
        (v) => v && v.toString().toLowerCase().includes(pesquisa.toLowerCase())
      );
    },

    formatarData(data) {
      return formatadorData.aplicarMascaraEmDataIso(data, "-");
    },

    async obterUsuarios() {
      await usuarioApi
        .obterTodos()
        .then((response) => {
          this.usuarios = response.data.map((p) => new Usuario(p));
          this.usuariosAtivos = this.usuarios.filter((u) => !u.dataInativacao);
        })
        .catch((error) => reject(error.response));
    },

    async obterSetores() {
      await setorApi
        .obterTodos()
        .then((response) => {
          let setores = response.data.map((p) => new Setor(p));
          this.setoresApi = setores;
        })
        .catch((error) => reject(error.response));
    },

    async obterPerfis() {
      await perfilApi
        .obterTodos()
        .then((response) => {
          let perfis = response.data.map((p) => new Perfil(p));
          this.perfisApi = perfis;
        })
        .catch((error) => reject(error.response));
    },

    abrirModalUsuario(usuario) {
      if (usuario) {
        this.usuarioSelecionado = new Usuario(usuario);

        this.usuarioSelecionado.setores = this.usuarioSelecionado.setores.map(
          (s) => s.nome
        );
      } else {
        this.usuarioSelecionado = new Usuario();
      }
      this.mostrarModalUsuario = true;
    },

    fecharModalUsuario() {
      this.usuarioSelecionado = new Usuario();
      this.mostrarModalUsuario = false;
    },

    abrirModalInativar(id, login) {
      this.idUsuarioSelecionado = id;
      this.loginUsuarioSelecionado = login;
      this.mostrarModalInativar = true;
    },

    abrirModalAtivar(id, login) {
      this.idUsuarioSelecionado = id;
      this.loginUsuarioSelecionado = login;
      this.mostrarModalAtivar = true;
    },

    fecharModalInativar() {
      this.mostrarModalInativar = false;
    },

    fecharModalAtivar() {
      this.mostrarModalAtivar = false;
    },

    adicionarUsuario(usuario) {
      this.usuarios.push(usuario);
      this.usuariosAtivos.push(usuario);

      this.fecharModalUsuario();
      this.dispararMensagem("Usuário adicionado com sucesso!", "success", 3000);
    },

    erroAdicionarUsuario(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },

    editarUsuario(usuario) {
      let indice = this.usuarios.findIndex((u) => u.id === usuario.id);
      this.usuarios.splice(indice, 1, usuario);

      indice = this.usuariosAtivos.findIndex((u) => u.id === usuario.id);
      this.usuariosAtivos.splice(indice, 1, usuario);

      this.fecharModalUsuario();
      this.dispararMensagem("Usuário atualizado com sucesso!", "success", 3000);
    },

    erroEditarUsuario(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },

    //TODO setar a data inativação
    inativarUsuario(usuario) {
      let indice = this.usuarios.findIndex((u) => u.id === usuario.id);
      this.usuarios[indice].dataInativacao = new Date();

      indice = this.usuariosAtivos.findIndex((u) => u.id === usuario.id);
      this.usuariosAtivos.splice(indice, 1);

      this.fecharModalInativar(usuario);
      this.dispararMensagem("Usuário inativado com sucesso!", "success", 3000);
    },

    erroInativarUsuario(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },

    ativarUsuario(usuario) {
      let indice = this.usuarios.findIndex((u) => u.id === usuario.id);
      this.usuarios[indice].dataInativacao = null;

      this.usuariosAtivos.push(new Usuario(this.usuarios[indice]));

      this.fecharModalAtivar(usuario);
      this.dispararMensagem("Usuário ativado com sucesso!", "success", 3000);
    },

    erroAtivarUsuario(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },
  },

  async mounted() {
    await this.obterDados();
  },
};
</script>

<style lang="scss" scoped>
.chip-min-width {
  width: 80px;
  display: flex;
  justify-content: center;
}

.chip-font-size {
  font-size: 14px;
}

.texto-erro-conexao {
  color: red;
}

.flex-row-chips {
  display: flex;
  flex-wrap: wrap;
}
</style>
